import React from "react";
import { PageShell } from "../components/Layout";
import { Smartphone, Bell, Zap, ShieldCheck, Download } from "lucide-react";

const FEATURES = [
  { icon: Bell, title: "Daily Teer Result", desc: "Get F/R & S/R the moment it's out" },
  { icon: Zap, title: "Fast Common Number", desc: "Instant common & dream numbers" },
  { icon: ShieldCheck, title: "Accurate & Trusted", desc: "Reliable analysis & prediction" },
  { icon: Download, title: "Instant Update", desc: "Push notifications on every result" },
];

export default function AppDownload() {
  return (
    <PageShell title="Sunday Ground Teer App" subtitle="Accurate • Fast • Trusted">
      <div className="max-w-3xl mx-auto bg-gradient-to-b from-[#0c2a20] to-[#061a12] rounded-3xl p-8 text-white shadow-lg">
        <div className="flex flex-col sm:flex-row items-center gap-8">
          <div className="w-40 h-72 rounded-3xl bg-[#12352a] border-4 border-white/20 flex flex-col items-center justify-center shrink-0 shadow-2xl">
            <Smartphone className="w-16 h-16 text-[#ff7a4d] mb-3" />
            <span className="font-black text-lg text-center leading-tight">
              SUNDAY<br />GROUND<br />TEER
            </span>
          </div>
          <div className="flex-1 text-center sm:text-left">
            <h2 className="text-2xl font-black mb-2">Download the Sunday Ground Teer App</h2>
            <p className="text-gray-300 text-sm mb-5">
              Never miss a result. Get today's Sunday Ground Teer result, common number & dream number
              right on your phone.
            </p>
            <div className="flex gap-3 justify-center sm:justify-start flex-wrap">
              <button className="bg-[#e8491d] hover:bg-[#c53a12] transition-colors px-5 py-3 rounded-xl font-bold flex items-center gap-2">
                <Download className="w-4 h-4" /> Google Play
              </button>
              <button className="bg-white/10 hover:bg-white/20 transition-colors px-5 py-3 rounded-xl font-bold flex items-center gap-2 border border-white/20">
                <Download className="w-4 h-4" /> App Store
              </button>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
          {FEATURES.map((f) => (
            <div key={f.title} className="bg-white/5 rounded-xl p-4 border border-white/10">
              <f.icon className="w-6 h-6 text-[#ff7a4d] mb-2" />
              <div className="font-bold text-sm">{f.title}</div>
              <div className="text-xs text-gray-400 mt-0.5">{f.desc}</div>
            </div>
          ))}
        </div>
        <p className="text-center text-xs text-gray-400 mt-6">
          * App download is a demo placeholder for now.
        </p>
      </div>
    </PageShell>
  );
}
